var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0.25C3.71875 0.25 0.25 3.75 0.25 8C0.25 12.2812 3.71875 15.75 8 15.75C12.25 15.75 15.75 12.2812 15.75 8C15.75 3.75 12.25 0.25 8 0.25ZM8 14.25C4.53125 14.25 1.75 11.4688 1.75 8C1.75 4.5625 4.53125 1.75 8 1.75C11.4375 1.75 14.25 4.5625 14.25 8C14.25 11.4688 11.4375 14.25 8 14.25ZM8 3.6875C7.25 3.6875 6.6875 4.28125 6.6875 5C6.6875 5.75 7.25 6.3125 8 6.3125C8.71875 6.3125 9.3125 5.75 9.3125 5C9.3125 4.28125 8.71875 3.6875 8 3.6875ZM9.75 11.625V10.875C9.75 10.6875 9.5625 10.5 9.375 10.5H9V7.375C9 7.1875 8.8125 7 8.625 7H6.625C6.40625 7 6.25 7.1875 6.25 7.375V8.125C6.25 8.34375 6.40625 8.5 6.625 8.5H7V10.5H6.625C6.40625 10.5 6.25 10.6875 6.25 10.875V11.625C6.25 11.8438 6.40625 12 6.625 12H9.375C9.5625 12 9.75 11.8438 9.75 11.625Z",
    fill: "#323232"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircle);
export default __webpack_public_path__ + "static/media/info-circle.0d998029.svg";
export { ForwardRef as ReactComponent };